import { lazy } from 'react';

// Lazy load pages that are not immediately needed
export const LazyAboutPage = lazy(() => import('../pages/AboutPage'));
export const LazyAcademicsPage = lazy(() => import('../pages/AcademicsPage'));
export const LazyAdmissionsPage = lazy(() => import('../pages/AdmissionsPage'));
export const LazyAlumniPage = lazy(() => import('../pages/AlumniPage'));
export const LazyContactPage = lazy(() => import('../pages/ContactPage'));
export const LazyGalleryPage = lazy(() => import('../pages/GalleryPage'));
export const LazyNewsPage = lazy(() => import('../pages/NewsPage'));
export const LazyFaqPage = lazy(() => import('../pages/FaqPage'));
export const LazyAccreditationPage = lazy(() => import('../pages/AccreditationPage'));
export const LazyHealthSafetyPage = lazy(() => import('../pages/HealthSafetyPage'));
export const LazyEmergencyProtocolsPage = lazy(() => import('../pages/EmergencyProtocolsPage'));

// Academic program pages
export const LazyPreschoolPage = lazy(() => import('../pages/PreschoolPage'));
export const LazyElementarySchoolPage = lazy(() => import('../pages/ElementarySchoolPage'));
export const LazyMiddleSchoolPage = lazy(() => import('../pages/MiddleSchoolPage'));
export const LazyHighSchoolPage = lazy(() => import('../pages/HighSchoolPage'));
export const LazyEarlyYearsPage = lazy(() => import('../pages/EarlyYearsPage'));

// Resource pages
export const LazyParentResourcesPage = lazy(() => import('../pages/ParentResourcesPage'));
export const LazyResourcesPage = lazy(() => import('../pages/ResourcesPage'));
export const LazyCalendarPage = lazy(() => import('../pages/CalendarPage'));
export const LazyAcademicResultsPage = lazy(() => import('../pages/AcademicResultsPage'));

// School information pages
export const LazyFacultyPage = lazy(() => import('../pages/FacultyPage'));
export const LazyEmploymentPage = lazy(() => import('../pages/EmploymentPage'));
export const LazyCurriculumPage = lazy(() => import('../pages/CurriculumPage'));
export const LazyTechnologyPage = lazy(() => import('../pages/TechnologyPage'));
export const LazyLearningSupport = lazy(() => import('../pages/LearningSupport'));

// Activities and community pages
export const LazyActivitiesPage = lazy(() => import('../pages/ActivitiesPage'));
export const LazyCommunityServicePage = lazy(() => import('../pages/CommunityServicePage'));
export const LazySocialMediaPage = lazy(() => import('../pages/SocialMediaPage'));

// Policy pages
export const LazyUniversityCounselingPage = lazy(() => import('../pages/UniversityCounselingPage'));

// Preload critical routes
export const preloadCriticalRoutes = () => {
  // Preload routes that users are likely to visit
  const criticalRoutes = [
    () => import('../pages/AboutPage'),
    () => import('../pages/AcademicsPage'),
    () => import('../pages/AdmissionsPage'),
    () => import('../pages/ContactPage')
  ];

  // Preload after initial page load
  if (document.readyState === 'complete') {
    criticalRoutes.forEach(importFn => {
      // Use requestIdleCallback if available, otherwise setTimeout
      if ('requestIdleCallback' in window) {
        requestIdleCallback(() => importFn());
      } else {
        setTimeout(() => importFn(), 100);
      }
    });
  } else {
    window.addEventListener('load', () => {
      criticalRoutes.forEach(importFn => {
        if ('requestIdleCallback' in window) {
          requestIdleCallback(() => importFn());
        } else {
          setTimeout(() => importFn(), 100);
        }
      });
    });
  }
};
